import React from 'react';
import { Icon } from '@iconify/react';
import { Helmet } from "react-helmet";
import { useTranslations } from '../../hooks/use-translations.js';
import { PreguntasSinLogin } from './PreguntasSinLogin.js';
import { useLanguage } from '../../hooks/use-language.js';
import { useId } from '../../hooks/use-id.js';

/**
 * Componente de ayuda sin login
 * @returns {JSX.Element} AyudaSinLogin
 */
export const AyudaSinLogin = () => {
    const lang = useLanguage();
    const texts = useTranslations({ section: "ayuda_sin_login", lang: lang });

    const contactTitle= useId('contact-title');

    return (
        <>
            <Helmet>
                <title>{`${texts?.metadata?.title || 'MakeMake - Ayuda'}`}</title>
                <meta name="description" content={texts?.metadata?.description || 'Resuelve dudas y preguntas frecuentes con vídeos tutoriales de ayuda.'} />
            </Helmet>
            <div className="main-container pb-5">
                <div className="main-content container py-5">
                    <div className='instrucciones-app'>
                        <h1  className="mb-2 text-center py-2">{texts?.instrucciones?.titulo || 'Ayuda'}</h1>
                        <div className="row">
                            {/* AYUDA PRGUNTAS */}
                            <div className="col-lg-8 p-0 pr-lg-5">
                                <p className='onbackground-primary--color my-3'>{texts?.instrucciones?.descripcion || 'MakeMake es una plataforma de suscripción a libros para niños y jóvenes diseñada especialmente para colegios y bibliotecas.'}</p>

                                <PreguntasSinLogin txtAyuda={texts?.pregunta} />
                            </div>
                            {/* datos de contacto */}
                            <aside aria-labelledby={contactTitle} className="col-lg-4 mb-3 mb-lg-0 p-0 mt-4 mt-lg-0">
                                <h2 id={contactTitle} className="sr-only">
                                    {texts?.accesibilidad?.cont_ayuda || 'Información de contacto'}
                                </h2>
                                <div className='datos-de-contacto'>
                                    <img src='../img/eyex-pregunta.png' className='instrucciones-app-eyex d-none d-lg-block' alt="" aria-hidden={true} />
                                    <h3 className='text-center  text-lg-left' >{texts?.datos_contacto?.titulo || 'Datos de contacto America latina'}</h3>
                                    <address>
                                    <div className='mt-3 row justify-content-center justify-content-lg-start m-0'>
                                        <Icon icon="ic:round-email" width={30} />
                                        <a href={`mailto:${texts?.datos_contacto?.correo || 'contacto@makemake.com.co'}`} className='focusable-secondary ml-2'
                                        aria-label={`${texts?.accesibilidad?.enviar_correo ||"Enviar correo a"} ${texts?.datos_contacto?.correo || 'contacto@makemake.com.co'}`}> {texts?.datos_contacto?.correo || 'contacto@makemake.com.co'}</a>
                                    </div>
                                    <div className='mt-3 row m-0 justify-content-center justify-content-lg-start align-items-start'>
                                        <Icon icon="ri:whatsapp-fill" width={30} />
                                        <div className='ml-2'>
                                            <a
                                                href={texts?.datos_contacto?.num_uno?.link || "https://wa.link/vuju91"}
                                                className="focusable-secondary d-block"
                                            >
                                                +{texts?.datos_contacto?.num_uno?.numero || '57 313 4509992'}
                                            </a>
                                            <a
                                                href={texts?.datos_contacto?.num_dos?.link || "https://wa.link/aozzbk"}
                                                className="focusable-secondary d-block"
                                            >
                                                +{texts?.datos_contacto?.num_dos?.numero || '57 350 2367037'}
                                            </a>
                                        </div>
                                    </div>
                                    </address>
                                    <h3 className='text-center  text-lg-left mt-3' >{texts?.datos_contacto?.usa?.titulo || 'Datos de contacto Estados Unidos'}</h3>
                                    <address>
                                    <div className='mt-3 row justify-content-center justify-content-lg-start m-0'>
                                        <Icon icon="ic:round-email" width={30} className='mt-1' />
                                        <div>
                                            <a href={`mailto:info@chinita.online`} className='focusable-secondary ml-2' aria-label={`${texts?.accesibilidad?.enviar_correo ||"Enviar correo a"} info@chinita.online`}> info@chinita.online</a>
                                            <br />
                                            <a href={`mailto:contacto@makemake.com.co`} className='focusable-secondary ml-2' aria-label={`${texts?.accesibilidad?.enviar_correo ||"Enviar correo a"} contacto@makemake.com.co`}> contacto@makemake.com.co</a>
                                        </div>
                                    </div>
                                    <div className='mt-3 row m-0 justify-content-center justify-content-lg-start align-items-start'>
                                        <Icon icon="ic:baseline-local-phone" width={30} />
                                        <div className='ml-2'>
                                            <p
                                                className="focusable-secondary d-block"
                                            >
                                                {`+1 (310) 690 0297`}
                                            </p>
                                        </div>
                                    </div>
                                    </address>
                                </div>

                            </aside>


                            
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}